import { z } from 'zod';

export const accountSchema = z.object({
  id: z.number(),
  name: z.string(),
  cdc_criteria: z.string().nullable(),
  account_criteria: z.string().nullable(),
  trec_id: z.number(),
  broker_name: z.string(),
});

export type AccountSchema = z.infer<typeof accountSchema>;

export const accountFormSchema = z.object({
  name: z.string().min(2, {
    error: 'Name must be at least 2 characters.',
  }),
  cdc_criteria: z.string(),
  account_criteria: z.string(),
});

export type AccountFormSchema = z.infer<typeof accountFormSchema>;
